import React, { PropsWithChildren, useEffect, useState } from "react";
import { styled } from "../../stitches.config";

interface Props {
  percent: number;
}

const ProgressBar: React.FC<PropsWithChildren<Props>> = ({ children, percent }) => {
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    requestAnimationFrame(() => {
      setProgress(percent);
    });
  }, [percent]);
  return (
    <StyledProgressBar style={{ width: `${progress}%` }}>
      {children}
    </StyledProgressBar>
  );
};

const StyledProgressBar = styled("div", {
  height: "100%",
  width: 0,
  backgroundColor: "$natematPrimary",
  transition: "1s ease",
  transitionDelay: "0.1s",
});

export default ProgressBar;
